"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchPatchLocationsDto = void 0;
const tslib_1 = require("tslib");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const interface_1 = require("../interface");
const generated_dto_1 = require("../generated-dto");
class BatchPatchLocationsDto {
}
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({
        type: () => String,
        isArray: true,
        example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921',
        uniqueItems: true,
    }),
    (0, class_transformer_1.Expose)({ groups: [interface_1.LocationExposeGroupEnum.BATCH_PATCH] }),
    (0, class_validator_1.IsArray)({ always: true }),
    (0, class_validator_1.IsString)({ each: true, always: true }),
    tslib_1.__metadata("design:type", Array)
], BatchPatchLocationsDto.prototype, "locationIds", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => generated_dto_1.BatchPatchLocationDto),
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => generated_dto_1.BatchPatchLocationDto }),
    (0, class_transformer_1.Expose)({ groups: [interface_1.LocationExposeGroupEnum.BATCH_PATCH] }),
    (0, class_validator_1.ValidateNested)({ always: true }),
    tslib_1.__metadata("design:type", generated_dto_1.BatchPatchLocationDto)
], BatchPatchLocationsDto.prototype, "data", void 0);
exports.BatchPatchLocationsDto = BatchPatchLocationsDto;
//# sourceMappingURL=BatchPatchLocationsDto.js.map